export default __webpack_public_path__ + "static/media/spinner_linear.d319af95.svg";